import type { BaseController } from '@infra/controllers/base.controller';
import type { DisconnectedTransferCallUsecase } from './disconnect-transfer-call.usecase';

export type DisconnectedTransferCallInput = void;

export type DisconnectedTransferCallOutput = void;

export class DisconnectedTransferCallController
  implements
    BaseController<
      DisconnectedTransferCallInput,
      DisconnectedTransferCallOutput
    >
{
  constructor(private usecase: DisconnectedTransferCallUsecase) {}

  async handle(): Promise<DisconnectedTransferCallOutput> {
    await this.usecase.run();
  }
}
